import { RouteEntities } from "../../core/routes/relativeRoutes";

export const lensInsightsTabs = [
    RouteEntities.Audience,
    RouteEntities.Engagement,
    RouteEntities.EventInsights,
    RouteEntities.Conversion,
    RouteEntities.Funnel,
    RouteEntities.Monetization,
] as const;

export type LensInsightsTab = (typeof lensInsightsTabs)[number];
export type TabVisibilityMap = Record<LensInsightsTab, boolean>;
